__turbopack_context__.v({
  "buttonContent": "QuickSearchResultsFooter-module__hcfczW__buttonContent",
  "buttonLabel": "QuickSearchResultsFooter-module__hcfczW__buttonLabel",
  "footer": "QuickSearchResultsFooter-module__hcfczW__footer",
  "shortcutContainer": "QuickSearchResultsFooter-module__hcfczW__shortcutContainer",
});
